module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer009"
    }
  }, [_c('p', {
    staticClass: "cn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagexi",
      "title": "xi"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "x50"
  }, [_c('img', {
    staticClass: "i300",
    attrs: {
      "alt": "circle",
      "src": "image/Circle.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "_ct",
    attrs: {
      "id": "_idParaDest-5"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "DropCap"
  }, [_c('span', {
    staticClass: "Brandon _idGenCharOverride-1"
  }, [_vm._v("All false modesty aside, ")]), _vm._v("nothing of value I’ve ever accomplished has been a solitary effort, done in a vacuum. My best work has always been done in collaboration, and this book is no exception. The following company of good spirits were instrumental in the creation and completion of this text, and I’m endlessly grateful to every one of them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("First and last and always, my beloved life partner Megan Langley: my heart, my muse, my inspiration, my greatest supporter, my primary interlocutor, and the best alpha reader a writer could hope to find. You provided every kind of support a first-time author could hope for, and this book would literally not exist without you. Thank you for everything, dearest one.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagexii",
      "title": "xii"
    }
  }, [_vm._v("Laura Tempest Zakroff, who kicked me under the bus once in Atlanta, and again in San Jose. #witchcraft, amirite?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jason Mankey, my editor at Patheos Pagan, who took a chance on a totally unknown writer on the basis of a tipsy introduction, a recommendation, and a writing sample.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Tai Fenix Kulystin, who instigated the essay that mutated over time into this work, and who provided invaluable insight into the nature of Babalon.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Everyone at Llewellyn Worldwide, with special thanks to my editor Heather Greene, who managed to wrest the snark-hammer from my hands with grace and good humor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Michelle Belanger, who graciously consented to write the foreword to this book.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Lon Sarver, who contributed pivotal thoughts on Dionysus and classical Greek culture, and Jay Logan, who graciously checked my work on Antinous.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The members of the Patheos Pagan Illuminati, whose spiritual and conspiratorial support was instrumental to the completion of this book.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Willow Moon, Chris Bartlett, Kyra Laughlin, and Kayla Rosen, my fabulous Bookfish: the team of beta readers who did the work of heroes in pointing out all the many places where my slip was showing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Lauren Stein, James Larson, Haley Nichols, Makia Oaks, and all of the amazingly kind and tolerant staff of SoulFood CoffeeHouse in Redmond, WA, where a nontrivial amount of this book was written. Additional thanks to the Redmond location of the King County Library System, who put up with me using their Internet access and asking their staff all sorts of questions, ranging from the obvious to the perplexing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagexiii",
      "title": "xiii"
    }
  }, [_vm._v("Jean Marie Stine and Frankie Hill, who gave me invaluable guidance and timely advice on publishing and other matters germane to this text.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Rhea Shemayazi and Raven Bond, who inspired and encouraged me with their friendship, their writing, and the incandescent light of their love.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For those who find this sort of minutiae interesting, background listening for the writing of this book included Dirty Computer by Janelle Monáe, Thrice Woven by Wolves in the Throne Room, Dionysus by Dead Can Dance, Kilts and Corsets by Tuatha Dea, multiple albums by Rush and Queen, the first two seasons of Stranger Things, and lots of podcasts, including those listed in the appendix and several nerdy delights from the good folks over at LSG Media (www.libertystreetgeek.net). The author suggests pairing this book with a seasonally-appropriate beverage, good lighting, and a comfy chair.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This book is written in loving memory of Rheya Blackfire, Raven Bond, Niklas Gander, Ron Miller, and Valerie “Veedub” Walker.")]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "href": "#/Contents#_idTextAnchor000"
    }
  }, [_vm._v("[contents]")])]), _vm._v(" "), _c('p', {
    staticClass: "tx _idGenParaOverride-1"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagexiv",
      "title": "xiv"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e8d68e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OCC.vue
// module id = 72
// module chunks = 0